import styled from 'styled-components/macro';
import { deviceMax } from 'utils/styles/breakpoints';
import { COLORS } from 'utils/styles/colors';
import { FLEX_CONTAINER } from 'utils/styles/flex';
import { FONTS, FONT_FAMILY } from 'utils/styles/fonts';

export const ImagesContainer = styled.div`
  ${FLEX_CONTAINER.FlexRow}

  @media ${deviceMax.mobileS} {
    ${FLEX_CONTAINER.FlexColumn}
  }

  @media ${deviceMax.tablet} {
    flex-direction: row;
    margin-left: 80px;
    margin-bottom: 80px;
  }

  @media ${deviceMax.laptopL} {
    flex-direction: row;
    margin-left: 166px;
    margin-bottom: 80px;
  }

  @media ${deviceMax.desktop} {
    margin-bottom: 150px;
    margin-left: 238px;
  }

  .people {
    @media ${deviceMax.mobileS} {
      width: 90%;
      height: 480px;
      margin-top: 150px;
    }

    @media ${deviceMax.mobileS} {
      margin-top: 55px;
    }

    @media ${deviceMax.mobileL} {
      width: 348px;
      height: 478px;
      margin-top: 36px;
    }

    @media ${deviceMax.tablet} {
      width: 364px;
      height: 480px;
      margin-top: 0;
    }

    @media ${deviceMax.laptopL} {
      width: 694px;
      height: 914px;
    }

    @media ${deviceMax.desktop} {
      width: 986px;
      height: 1326px;
    }
  }

  .sun {
    position: absolute;
    right: 0;

    @media ${deviceMax.mobileS} {
      display: none;
    }

    @media ${deviceMax.tablet} {
      display: block;
      width: 240px;
      height: 404px;
    }

    @media ${deviceMax.laptopL} {
      width: 250px;
      height: 516px;
      margin-bottom: 100px;
    }

    @media ${deviceMax.desktop} {
      width: 435px;
      height: 988px;
      margin-top: 0;
    }
  }
`;

export const TeamWord = styled.div`
  @media ${deviceMax.mobileS} {
    margin-bottom: 330px;
  }

  @media ${deviceMax.tablet} {
    margin-bottom: 450px;
  }

  @media ${deviceMax.laptopL} {
    margin-bottom: 500px;
  }

  @media ${deviceMax.desktop} {
    margin-bottom: 790px;
  }

  img {
    width: 100%;
  }

  div {
    ${FLEX_CONTAINER.FlexRow}
    width: 100%;
    margin-top: 6px;
  }

  p {
    ${FONT_FAMILY.FontBold}
    color: ${COLORS.blueBlack};

    @media ${deviceMax.mobileS} {
      margin-bottom: 36px;
      ${FONTS.font16}
    }

    @media ${deviceMax.tablet} {
      ${FONTS.font16}
      margin-bottom: 40px;
    }

    @media ${deviceMax.laptopL} {
      ${FONTS.font20}
      margin-bottom: 54px;
    }

    @media ${deviceMax.desktop} {
      ${FONTS.font24}
      margin-bottom: 74px;
    }
  }
`;

export const StyledAboutContainer = styled.div`
  background: ${COLORS.lightGray};
  padding-top: 46px;
  .about-us-box {
    height: 1200px;
  }
`;
